<template>
    <div>
        <created-offer-alert v-if="last_created_offer" :offer="last_created_offer"
            @sendEmail="sendEmailEvent($event)" />
        <offers-by-month v-if="dashboard == 1" :data="filteredOffers" :user="user" :is_paid="is_paid"
            @resetOpens="resetOpens($event)" @changeSendStatus="changeSendStatus($event)"
            @deleteOffer="deleteOffer($event)" @de_activeOffer="de_activeOffer($event)"
            @isFormConfirmed="isFormConfirmed($event)" @openKlientModal="openKlientModal($event)" />
        <div v-if="dashboard == 0" class="pcoded-content">
            <under-bar-name :title="$t('offer.table_title')" :margin="true" />
            <div class="page-header card mt-0" style="border: none">
                <div class="row align-items-end">
                    <!-- <three-offers v-if="premium == 'false'" :offers="all_offers_count" /> -->
                    <div class="col-lg-12 offer_count pb-0">
                        <div class="page-header-title d-flex align-items-center justify-content-between">
                            <h5>
                                {{ $t('offer.table_header') }} ({{ all_offers_count }})
                                <small v-if="canSearch() && !search_for_offers" @click="removeFilter()"
                                    class="removeFilter">{{ $t('offer.clear_filter') }}</small>
                            </h5>
                            <div class="header_actions">
                                <span class="ai_offer_btn" @click="openAiOffer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
                                        fill="none">
                                        <path
                                            d="M9 1.5L10.6 6.4L15.5 8L10.6 9.6L9 14.5L7.4 9.6L2.5 8L7.4 6.4L9 1.5Z"
                                            fill="currentColor" />
                                        <path d="M14.75 12.25L15.4 14.1L17.25 14.75L15.4 15.4L14.75 17.25L14.1 15.4L12.25 14.75L14.1 14.1L14.75 12.25Z"
                                            fill="currentColor" />
                                    </svg>
                                    {{ $t('ai_offer.button_generate') }}
                                    <paid-modal-icon v-if="!aiAllowed" :openModal="paid_modal_open"
                                        @close="paid_modal_open = false" />
                                </span>
                                <a href="/admin/offers/create" class="create_offer_btn">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21"
                                        fill="none">
                                        <g opacity="0.6">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M10 3.5C10.2652 3.5 10.5196 3.60536 10.7071 3.79289C10.8946 3.98043 11 4.23478 11 4.5V9.5H16C16.2652 9.5 16.5196 9.60536 16.7071 9.79289C16.8946 9.98043 17 10.2348 17 10.5C17 10.7652 16.8946 11.0196 16.7071 11.2071C16.5196 11.3946 16.2652 11.5 16 11.5H11V16.5C11 16.7652 10.8946 17.0196 10.7071 17.2071C10.5196 17.3946 10.2652 17.5 10 17.5C9.73478 17.5 9.48043 17.3946 9.29289 17.2071C9.10536 17.0196 9 16.7652 9 16.5V11.5H4C3.73478 11.5 3.48043 11.3946 3.29289 11.2071C3.10536 11.0196 3 10.7652 3 10.5C3 10.2348 3.10536 9.98043 3.29289 9.79289C3.48043 9.60536 3.73478 9.5 4 9.5H9V4.5C9 4.23478 9.10536 3.98043 9.29289 3.79289C9.48043 3.60536 9.73478 3.5 10 3.5Z"
                                                fill="white" />
                                        </g>
                                    </svg>
                                    {{ $t('offer.create') }}
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 filter1 pt-0">
                        <div class="page-header-title d-flex align-items-center position-relative">
                            <input v-model="search" class="filter_input" type="text"
                                :placeholder="$t('offer.search_placeholder')" />
                            <svg class="filter_svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                <mask id="path-1-inside-1" fill="white">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M11.4947 4.42476C13.4129 6.41116 13.3577 9.5765 11.3713 11.4947C9.38488 13.413 6.21953 13.3577 4.30129 11.3713C2.38304 9.38494 2.43829 6.2196 4.4247 4.30135C6.4111 2.38311 9.57644 2.43836 11.4947 4.42476ZM13.5589 12.0175C15.5266 9.32026 15.3321 5.51944 12.9334 3.03544C10.2478 0.254479 5.81634 0.177127 3.03538 2.86267C0.254416 5.54822 0.177064 9.9797 2.86261 12.7607C5.31231 15.2974 9.21474 15.5845 11.992 13.5771L12.9187 14.5367L13.4306 15.0667L14.8199 16.5054L14.9713 16.3592L16.2586 15.1161L16.41 14.9699L15.0207 13.5312L14.5088 13.0011L13.5589 12.0175Z" />
                                </mask>
                                <path
                                    d="M13.5589 12.0175L11.9432 10.8388L10.9522 12.1972L12.1203 13.4068L13.5589 12.0175ZM11.992 13.5771L13.4307 12.1878L12.226 10.9402L10.8204 11.9562L11.992 13.5771ZM12.9187 14.5367L14.3574 13.1474L12.9187 14.5367ZM13.4306 15.0667L11.9919 16.4561L13.4306 15.0667ZM14.8199 16.5054L13.3812 17.8947L14.7705 19.3334L16.2092 17.9441L14.8199 16.5054ZM14.9713 16.3592L13.582 14.9205L14.9713 16.3592ZM16.2586 15.1161L17.6479 16.5548L16.2586 15.1161ZM16.41 14.9699L17.7993 16.4085L19.238 15.0192L17.8487 13.5805L16.41 14.9699ZM15.0207 13.5312L13.582 14.9205L15.0207 13.5312ZM14.5088 13.0011L15.9475 11.6118L14.5088 13.0011ZM12.7606 12.9334C15.5416 10.2479 15.6189 5.8164 12.9334 3.03544L10.056 5.81408C11.207 7.00592 11.1738 8.90512 9.98196 10.0561L12.7606 12.9334ZM2.86261 12.7607C5.54815 15.5416 9.97963 15.619 12.7606 12.9334L9.98196 10.0561C8.79012 11.207 6.89092 11.1739 5.73997 9.98203L2.86261 12.7607ZM3.03538 2.86267C0.254416 5.54822 0.177064 9.9797 2.86261 12.7607L5.73997 9.98203C4.58902 8.79018 4.62217 6.89098 5.81401 5.74003L3.03538 2.86267ZM12.9334 3.03544C10.2478 0.254479 5.81634 0.177127 3.03538 2.86267L5.81401 5.74003C7.00585 4.58908 8.90506 4.62223 10.056 5.81408L12.9334 3.03544ZM15.1747 13.1962C17.7054 9.72716 17.4576 4.84131 14.372 1.64612L11.4947 4.42476C13.2067 6.19756 13.3478 8.91336 11.9432 10.8388L15.1747 13.1962ZM14.372 1.64612C10.9192 -1.9294 5.22159 -2.02885 1.64606 1.42399L4.4247 4.30135C6.4111 2.38311 9.57644 2.43836 11.4947 4.42476L14.372 1.64612ZM1.64606 1.42399C-1.92946 4.87684 -2.02891 10.5745 1.42393 14.15L4.30129 11.3713C2.38304 9.38494 2.43829 6.2196 4.4247 4.30135L1.64606 1.42399ZM1.42393 14.15C4.57473 17.4127 9.59131 17.7801 13.1636 15.198L10.8204 11.9562C8.83818 13.389 6.04988 13.1821 4.30129 11.3713L1.42393 14.15ZM10.5533 14.9664L11.48 15.926L14.3574 13.1474L13.4307 12.1878L10.5533 14.9664ZM11.48 15.926L11.9919 16.4561L14.8693 13.6774L14.3574 13.1474L11.48 15.926ZM11.9919 16.4561L13.3812 17.8947L16.2586 15.1161L14.8693 13.6774L11.9919 16.4561ZM16.2092 17.9441L16.3606 17.7979L13.582 14.9205L13.4306 15.0667L16.2092 17.9441ZM16.3606 17.7979L17.6479 16.5548L14.8693 13.6774L13.582 14.9205L16.3606 17.7979ZM17.6479 16.5548L17.7993 16.4085L15.0207 13.5312L14.8693 13.6774L17.6479 16.5548ZM17.8487 13.5805L16.4594 12.1419L13.582 14.9205L14.9713 16.3592L17.8487 13.5805ZM16.4594 12.1419L15.9475 11.6118L13.0702 14.3905L13.582 14.9205L16.4594 12.1419ZM15.9475 11.6118L14.9976 10.6282L12.1203 13.4068L13.0702 14.3905L15.9475 11.6118Z"
                                    fill="#DDE3E8" mask="url(#path-1-inside-1)" />
                            </svg>
                        </div>
                        <FilterSelect :offer_states="offer_states" :sub_users="sub_users" :moje_firmy="mojefirmy"
                            :selectedStates="selectedStates" :selectedUsers="selectedUsers"
                            :selectedMyCompanies="selectedMyCompanies" />
                    </div>
                    <div class="col-lg-6 filter2"></div>
                    <div v-if="search_for_offers" class="col-lg-6 mt-4 ml-1">
                        <div class="wrapper">
                            <div class="circle"></div>
                            <div class="circle"></div>
                            <div class="circle"></div>
                            <span>{{ $t('offer.searching') }}</span>
                        </div>
                    </div>
                    <div v-if="!search_for_offers && data_show.length <= 0" class="col-lg-6 mt-4 ml-1">
                        <div class="wrapper">
                            <span>{{ $t('offer.not_found') }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pcoded-inner-content pt-1 relative">
                <div class="main-body">
                    <div class="page-wrapper pt-0">
                        <div class="page-body" style="padding-bottom: 60px">
                            <offers-by-month :data="filteredOffers" :user="user" :is_paid="is_paid"
                                :sendEmail="sendEmail" @resetOpens="resetOpens($event)"
                                @changeSendStatus="changeSendStatus($event)" @deleteOffer="deleteOffer($event)"
                                @de_activeOffer="de_activeOffer($event)" @isFormConfirmed="isFormConfirmed($event)"
                                @openKlientModal="openKlientModal($event)" />

                            <div v-show="all_offers_count < 1" class="row">
                                <div class="col-lg-12">
                                    <div class="non_offer">
                                        <b>{{ $t('offer.empty_msg') }}</b>
                                        <a href="/admin/offers/create" class="create button">
                                            <svg class="mr-2" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="vertical-align: middle;"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                                            {{ $t('offer.create') }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!searched_offers && is_paid">
                                <button class="mt-5 zobrazitViac" v-if="load_more_offes_btn" @click="show_more_offer">
                                    <span v-show="show_offer_btn">
                                        {{ $t('offer.load_more') }}
                                    </span>
                                    <div v-show="!show_offer_btn" class="lds-ellipsis">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                </button>
                            </div>
                            <div v-if="searched_offers && is_paid">
                                <div class="lds-ellipsis green">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                            </div>
                            <div v-if="offer_updated" data-click="no" data-growl="container"
                                class="alert alert-success background-success alert-dismissable growl-animated animated"
                                v-bind:class="{
                                    bounceInLeft: offer_updated,
                                    bounceOutRight: !offer_updated,
                                }" role="alert" data-growl-position="top-right" style="
                                    position: fixed;
                                    margin: 0px;
                                    z-index: 999999;
                                    display: inline-block;
                                    top: 30px;
                                    right: 30px;
                                    width: auto;
                                ">
                                <button type="button" data-click="no" class="close" data-growl="dismiss"
                                    style="display: block; z-index: 999998">
                                    <span @click="offer_updated = false" aria-hidden="true" data-click="no">×</span>
                                </button>
                                <span data-growl="icon" data-click="no"></span>
                                <span data-growl="title" data-click="no">
                                    {{ $t('offer.updated_msg') }} <br />
                                    <div style="white-space: nowrap" data-click="no">
                                        URL ponuky:
                                        <a data-click="no" id="url_copy" v-bind:href="'/' +
                                            offer_exam.uuid +
                                            '/' +
                                            offer_exam.slug +
                                            '/' +
                                            offer_exam.id
                                            " target="_blank" style="
                                                color: #0f5132;
                                                font-weight: 500;
                                            ">{{ appOrigin }}/{{
                                                offer_exam.uuid
                                            }}/{{ offer_exam.slug }}/{{
                                                offer_exam.id
                                            }}</a>
                                        <i data-click="no" @click="copy()" class="fas fa-link ml-2 my_tooltip">
                                            <span class="my_tooltiptext" style="
                                                    font-weight: 500;
                                                    padding: 10px;
                                                ">
                                                {{ $t('offer.copy_url_tooltip') }}
                                            </span>
                                        </i>
                                    </div>
                                </span>
                                <span data-growl="message" data-click="no"></span>
                                <a href="#" data-growl="url" data-click="no"></a>
                            </div>
                            <div class="notifications2" data-click="no">
                                <button id="target" ref="submitBtn" class="btn btn-primary waves-effect click d-none"
                                    :data-title="this.message" data-type="success"
                                    data-animation-in="animated bounceInLeft"
                                    data-animation-out="animated bounceOutRight" data-click="no"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <klient-create :editKlient="getCurrentKlient" :openModal="modalKlient" :klients="klients"
            :props_zdroj_kontaktu="props_zdroj_kontaktu" @closeModal="modalKlient = $event" @reload="reload" />
    </div>
</template>
<script>
import { ModelListSelect } from "vue-search-select";
import ThreeOffers from "../no_premium/ThreeOffers.vue";
import OffersByMonth from "./OfferTable_components/OffersByMonth.vue";
import FilterSelect from "./OfferTable_components/FilterSelect.vue";
import KlientCreate from "../klient/components/KlientCreate.vue";
import CreatedOfferAlert from "../vue_components/CreatedOfferAlert.vue";
import PaidModalIcon from "../vue_components/PaidModalIcon.vue";
import { EventBus } from "./components/EventBus.js";
export default {
    props: [
        "dashboard",
        "premium",
        "offers",
        "mojefirmy",
        "user",
        "sub_users",
        "offer_states",
        "klients",
        "props_zdroj_kontaktu",
        "is_paid",
        "create_offer_alert",
        "last_created_offer",
    ],
    components: {
        ModelListSelect,
        ThreeOffers,
        OffersByMonth,
        FilterSelect,
        KlientCreate,
        CreatedOfferAlert,
        PaidModalIcon,
    },
    data() {
        return {
            paid_modal_open: false,
            search: "",
            load_more_offes_btn: true,
            show_offer_btn: true,
            searched_offers: false,
            search_for_offers: false,
            search_offers: [],
            data_without_search: [],
            data_with_search: [],
            data_show: [],
            klient: "",
            message: "",
            offer_updated: false,
            all_offers_count: 0,
            show_offer_offset: 0,
            show_offer_limit: 10,
            offer_exam: null,

            selectedStates: [],
            selectedUsers: [],
            selectedMyCompanies: [],
            modalKlient: false,
            currentKlientId: null,

            sendEmail: null,
            search_offset: 0,
            search_limit: 10,
            searching_more: false,
        };
    },
    created() {
        this.data_without_search = this.offers.offers_by_date;
        this.all_offers_count = this.offers.all_offers;
        this.data_show = this.data_without_search;
        if (
            sessionStorage.flashmessage == "success" &&
            !this.last_created_offer
        ) {
            this.offer_exam = {
                uuid: sessionStorage.flashmessage_uuid,
                slug: sessionStorage.flashmessage_slug,
                id: sessionStorage.flashmessage_id,
            };
            sessionStorage.removeItem("flashmessage");
            sessionStorage.removeItem("flashmessage_uuid");
            sessionStorage.removeItem("flashmessage_slug");
            sessionStorage.removeItem("flashmessage_id");
            this.offer_updated = true;
            setTimeout(() => (this.offer_updated = false), 8000);
        }
    },
    mounted() {
        EventBus.$on("open-paid-modal", this.showPaidModal);
    },
    beforeDestroy() {
        EventBus.$off("open-paid-modal", this.showPaidModal);
    },
    methods: {
        showPaidModal() {
            this.paid_modal_open = true;
        },
        // Free plan k AI ponukam pristup nema — namiesto modalu dostane upsell.
        openAiOffer() {
            if (!this.aiAllowed) {
                this.paid_modal_open = true;
                return;
            }
            EventBus.$emit("open-ai-offer-modal");
        },
        sendEmailEvent(uuid) {
            this.sendEmail = uuid;
        },
        reload() {
            window.location.reload();
        },
        openKlientModal(id) {
            this.modalKlient = true;
            this.currentKlientId = id;
        },
        removeFilter() {
            this.search = null;
            this.selectedMyCompanies = [];
            this.selectedStates = [];
            this.selectedUsers = [];
        },
        async show_more_offer() {
            this.show_offer_btn = false;
            if (this.canSearch()) {
                this.search_offset += this.search_limit;
                await this.loadMoreSearching();
            } else {
                this.show_offer_offset += this.show_offer_limit;
                await this.loadMoreDefault();
            }
            this.show_offer_btn = true;
        },
        async loadMoreSearching() {
            await axios
                .post("/api/offers/filter/set", {
                    offername_klient: this.search,
                    my_companies: this.selectedMyCompanies,
                    offer_states: this.selectedStates,
                    my_users: this.selectedUsers,
                    offset: this.search_offset,
                    limit: this.search_limit,
                })
                .then((response) => {
                    if (this.search_offset === 0) {
                        this.data_show = response.data.offers_by_date;
                    } else {
                        const newData = response.data.offers_by_date;
                        this.appendOffersByDate(this.data_show, newData);
                    }
                    this.search_for_offers = false;
                    this.loaded_last = response.data.loaded < this.search_limit;
                    this.load_more_offes_btn = !this.loaded_last;
                });
        },
        async loadMoreDefault() {
            await axios
                .get(
                    "/api/offers/byCount/" +
                    this.show_offer_offset +
                    "/" +
                    this.show_offer_limit +
                    ""
                )
                .then((response) => {
                    this.show_offer_offset += this.show_offer_limit;
                    const newData = response.data.offers_by_date;
                    this.appendOffersByDate(this.data_without_search, newData);
                });
        },
        deleteOffer(id) {
            this.data_without_search.forEach((data) => {
                data.offers.forEach((element) => {
                    if (element.offer.id == id) {
                        const index = data.offers.indexOf(element);
                        data.offers.splice(index, 1);
                        this.all_offers_count--;
                    }
                });
                if (data.offers.length < 1) {
                    const index2 = this.data_without_search.indexOf(data);
                    this.data_without_search.splice(index2, 1);
                }
            });
            this.search_offers.forEach((data) => {
                data.offers.forEach((element) => {
                    if (element.offer.id == id) {
                        const index = data.offers.indexOf(element);
                        data.offers.splice(index, 1);
                        this.all_offers_count--;
                    }
                });
                if (data.offers.length < 1) {
                    const index2 = this.search_offers.indexOf(data);
                    this.search_offers.splice(index2, 1);
                }
            });
        },
        de_activeOffer(uuid) {
            this.data_without_search.forEach((data) => {
                data.offers.forEach((element) => {
                    if (element.offer.uuid == uuid) {
                        element.offer.active == 0
                            ? (element.offer.active = 1)
                            : (element.offer.active = 0);
                    }
                });
            });
            this.search_offers.forEach((data) => {
                data.offers.forEach((element) => {
                    if (element.offer.uuid == uuid) {
                        element.offer.active == 0
                            ? (element.offer.active = 1)
                            : (element.offer.active = 0);
                    }
                });
            });
        },
        isFormConfirmed(uuid) {
            this.data_without_search.forEach((data) => {
                data.offers.forEach((element) => {
                    if (element.offer.uuid == uuid) {
                        element.offer.isFormConfirmed = 2;
                    }
                });
            });
            this.search_offers.forEach((data) => {
                data.offers.forEach((element) => {
                    if (element.offer.uuid == uuid) {
                        element.offer.isFormConfirmed = 2;
                    }
                });
            });
        },
        resetOpens(id) {
            this.data_without_search.forEach((data) => {
                data.offers.forEach((element) => {
                    if (element.offer.id == id) {
                        element.offer.opens = 0;
                    }
                });
            });
            this.search_offers.forEach((data) => {
                data.offers.forEach((element) => {
                    if (element.offer.id == id) {
                        element.offer.opens = 0;
                    }
                });
            });
        },
        changeSendStatus(uuid) {
            this.data_without_search.forEach((data) => {
                data.offers.forEach((element) => {
                    if (element.offer.uuid == uuid) {
                        element.offer.send_status == 0
                            ? (element.offer.send_status = 1)
                            : (element.offer.send_status = 0);
                    }
                });
            });
            this.search_offers.forEach((data) => {
                data.offers.forEach((element) => {
                    if (element.offer.uuid == uuid) {
                        element.offer.send_status == 0
                            ? (element.offer.send_status = 1)
                            : (element.offer.send_status = 0);
                    }
                });
            });
        },
        polozka_edit_remove() {
            sessionStorage.removeItem("edit_polozka");
        },
        copy() {
            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val($("#url_copy").text()).select();
            document.execCommand("copy");
            $temp.remove();
        },
        toolbox(id) {
            return this.data_without_search.filter((data) => {
                if (id == data.offer.id) {
                    if (data.offer.tooltip == 0) data.offer.tooltip = 1;
                    else data.offer.tooltip = 0;
                } else {
                    data.offer.tooltip = 0;
                }
            });
        },
        resetToolbox() {
            this.data_without_search.filter((data) => {
                data.offer.tooltip = 0;
            });
        },
        debounceInput: _.debounce(function (e) {
            this.loadMoreSearching();
        }, 800),
        canSearch() {
            return !(
                !this.search &&
                this.selectedMyCompanies.length <= 0 &&
                this.selectedStates.length <= 0 &&
                this.selectedUsers.length <= 0
            );
        },
        startSearching() {
            if (this.canSearch()) {
                this.search_offset = 0;
                this.search_for_offers = true;
                this.load_more_offes_btn = false;
                this.data_show = [];
                this.debounceInput();
            } else {
                this.load_more_offes_btn = true;
                this.search_for_offers = false;
                this.data_show = this.data_without_search;
            }
        },
        appendOffersByDate(targetArray, newData) {
            if (!Array.isArray(newData) || newData.length === 0) {
                return;
            }

            if (!Array.isArray(targetArray) || targetArray.length === 0) {
                newData.forEach((group) => targetArray.push(group));
                return;
            }

            const lastItem = targetArray[targetArray.length - 1];
            const firstNew = newData[0];

            let startIndex = 0;

            if (
                lastItem.year === firstNew.year &&
                lastItem.month === firstNew.month
            ) {
                firstNew.offers.forEach((o) => {
                    lastItem.offers.push(o);
                });
                startIndex = 1;
            }

            for (let i = startIndex; i < newData.length; i++) {
                targetArray.push(newData[i]);
            }
        },
    },
    watch: {
        selectedUsers() {
            this.startSearching();
        },
        selectedStates() {
            this.startSearching();
        },
        selectedMyCompanies() {
            this.startSearching();
        },
        search() {
            this.startSearching();
        },
    },
    computed: {
        // is_paid pride z blade ako 0/1, u sub-uzivatela sa pocita z predplatneho vlastnika.
        aiAllowed() {
            return Number(this.is_paid) === 1;
        },
        // Domena podla toho, kde user prave je (doffero.com / doffero.cz)
        appOrigin() {
            return window.location.origin;
        },
        getCurrentKlient() {
            return this.klients.find(
                (klient) => klient.id == this.currentKlientId
            );
        },
        filteredOffers() {
            return this.data_show;
        },
        searchMojeFirmy() {
            var data = [];
            if (this.mojefirmy.length > 0) {
                this.mojefirmy.forEach((firma) => {
                    data.push(firma.nazov);
                });
            }
            return data;
        },
        newOfferAlert() {
            return this.offers.offers_by_date[0].offers[0];
        },
    },
};
</script>
<style lang="scss">
.header_actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
}

.ai_offer_btn {
    display: flex;
    height: 50px;
    padding: 14px 18px;
    justify-content: center;
    align-items: center;
    gap: 7px;
    flex-shrink: 0;
    border-radius: 8px;
    border: 1px solid #dde3e8;
    background: #fff;
    color: #4c5667;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    user-select: none;

    svg {
        color: #4353a4;
    }

    &:hover {
        border-color: #4353a4;
        color: #4353a4;
        background: #f5f6fb;
    }
}

@media (max-width: 767px) {
    .header_actions {
        flex-wrap: wrap;
        gap: 8px;
    }

    .ai_offer_btn {
        padding: 12px 14px;
    }
}

.create_offer_btn {
    display: flex;
    width: 180px;
    height: 50px;
    padding: 14px 14px;
    justify-content: center;
    align-items: center;
    gap: 7px;
    flex-shrink: 0;
    border-radius: 8px;
    background: #2ed8b6;
    color: #fff;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-decoration: none;

    &:hover {
        text-decoration: none;
        background: #24b094;
        color: #fff;
    }
}

.removeFilter {
    color: #f93c34;
    font-family: Montserrat;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.5px;
    margin-left: 10px;
    cursor: pointer;
}

.combobox_mojefirmy_search .v-menu__content {
    left: 0 !important;
}

.swal2-popup {
    z-index: 10000;
}
</style>
<style lang="scss">
.wrapper {
    width: 200px;
    height: 60px;
}

.circle {
    width: 15px;
    height: 15px;
    position: absolute;
    border-radius: 50%;
    background-color: #2ed8b6;
    transform-origin: 50%;
    animation: circle 0.5s alternate infinite ease;
}

@keyframes circle {
    0% {
        top: 50px;
        height: 5px;
        border-radius: 50px 50px 25px 25px;
        transform: scaleX(1.7);
    }

    40% {
        height: 10px;
        border-radius: 50%;
        transform: scaleX(1);
    }

    100% {
        top: 0%;
    }
}

.circle:nth-child(2) {
    left: 40px;
    animation-delay: 0.2s;
}

.circle:nth-child(3) {
    left: 80px;
    animation-delay: 0.3s;
}

.wrapper span {
    position: absolute;
    top: 70px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 19px;
    line-height: 19px;
    letter-spacing: 1px;
    color: #212541;
}
</style>
<style lang="scss">
.zobrazitViac {
    width: 200px;
    height: 55px;
    background: #2ed8b6;
    border-radius: 4px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    transition: 0.5s all;

    &:focus {
        outline: none;
    }

    &:hover {
        background: #23caa9;
        color: #ffffff;
    }
}

.non_offer {
    a.button {
        position: absolute;
        left: 0;
        right: 0;
        bottom: -20px;
        margin: auto;
        width: 219px;
        height: 44px;
        background: #3455db;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        color: #ffffff;
    }
}

.filter1 {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 0;

    @media only screen and (max-width: 600px) {
        display: grid;
    }

    .filter_svg {
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        right: 15px;
        cursor: pointer;
    }

    .filter_svg2 {
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        right: 15px;
        cursor: pointer;
    }

    .filter_input {
        width: 300px;
        height: 45px;
        background: #ffffff;
        border: 1px solid #dde3e8;
        box-sizing: border-box;

        font-style: normal;
        font-weight: bold;
        font-size: 11px;
        line-height: 13px;
        letter-spacing: 0.1em;

        color: #9598a7;
        border-radius: 6px;

        padding: 15px;
    }

    .d-inline h5 {
        font-style: normal;
        font-weight: 600;
        font-size: 22px;
        line-height: 22px;
        display: flex;
        align-items: center;
        color: #212541;
    }

    .combobox_mojefirmy_search {
        margin-left: 30px;
        position: relative;

        .v-menu__content {
            left: 0 !important;
        }

        .v-input {
            width: 300px;
            height: 55px;
        }

        .theme--light.v-text-field--filled>.v-input__control>.v-input__slot {
            background: #fff;
        }

        input {
            font-family: Roboto !important;
            font-style: normal !important;
            font-weight: bold !important;
            font-size: 14px !important;
            line-height: 16px !important;
            color: #212541 !important;
        }

        .v-input__slot,
        .theme--light.v-text-field--filled>.v-input__control>.v-input__slot {
            background: #fff !important;
            border: 1px solid #dde3e8 !important;
            border-radius: 0 !important;

            input {
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 16px;
                color: #212541 !important;
            }
        }

        .v-text-field>.v-input__control>.v-input__slot {
            &:after {
                content: none !important;
            }

            &:before {
                content: none !important;
            }
        }

        .v-label.v-label--active.theme--light {
            left: -11px !important;
            top: 14px !important;
            font-family: Roboto !important;
            font-style: normal !important;
            font-weight: bold !important;
            font-size: 11px !important;
            line-height: 13px !important;
            letter-spacing: 0.1em !important;
            text-transform: uppercase !important;
            color: #9598a7 !important;
            margin-top: 0 !important;
        }

        .v-label.theme--light {
            top: 22px !important;
            font-family: Roboto !important;
            font-style: normal !important;
            font-weight: bold !important;
            font-size: 11px !important;
            line-height: 13px !important;
            letter-spacing: 0.1em !important;
            text-transform: uppercase !important;
            color: #9598a7 !important;
            margin-top: 0 !important;
        }
    }
}

.my_tooltiptext {
    top: 90%;
    pointer-events: none;
}

.select2-container {
    width: 100% !important;
}

.non_offer {
    align-items: center;
    display: flex;
    padding-bottom: 0 !important;
    height: 140px;
    display: grid;
    text-align: center;

    .create {
        margin: 20px auto;
    }
}

.lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}

.lds-ellipsis.green div {
    background: #2ed8b6;
}

.lds-ellipsis div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
}

@keyframes lds-ellipsis1 {
    0% {
        transform: scale(0);
    }

    100% {
        transform: scale(1);
    }
}

@keyframes lds-ellipsis3 {
    0% {
        transform: scale(1);
    }

    100% {
        transform: scale(0);
    }
}

@keyframes lds-ellipsis2 {
    0% {
        transform: translate(0, 0);
    }

    100% {
        transform: translate(24px, 0);
    }
}

@media (max-width: 600px) {
    .page-header-title {
        flex-direction: column !important;
        align-items: start !important;
        gap: 16px !important;
    }
}

@media (max-width: 1200px) {
    .page-header.card {
        margin-left: 30px !important;

        .row:first-child {
            flex-direction: column;
            align-items: start !important;
        }
    }

    .offer_count {
        order: 1;
    }

    .filter1 {
        order: 3;
    }

    .filter2 {
        order: 2;
        justify-content: flex-start;
    }
}

@media (max-width: 1000px) {
    .page-header.card {
        margin-left: 10px !important;
    }
}
</style>
